import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as systemErrorLogApi from '../../api/systemErrorLog';
import { message } from 'antd';

// 获取系统错误日志列表
export const fetchSystemErrorLogs = createAsyncThunk(
  'systemErrorLog/fetchList',
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await systemErrorLogApi.getSystemErrorLogList(params);
      if (response && response.code === 200) {
        return {
          data: response.data,
          params
        };
      }
      return rejectWithValue(response?.message || '获取系统错误日志失败');
    } catch (error) {
      return rejectWithValue(error.message || '获取系统错误日志失败');
    }
  }
);

// 初始状态
const initialState = {
  list: {
    records: [],
    total: 0,
    current: 1,
    size: 10,
    loading: false,
    error: null,
    searchParams: {}
  }
};

// 创建Slice
const systemErrorLogSlice = createSlice({
  name: 'systemErrorLog',
  initialState,
  reducers: {
    setSearchParams: (state, action) => {
      state.list.searchParams = {
        ...state.list.searchParams,
        ...action.payload
      };
    },
    clearError: (state) => {
      state.list.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      // 处理获取系统错误日志列表
      .addCase(fetchSystemErrorLogs.pending, (state) => {
        state.list.loading = true;
        state.list.error = null;
      })
      .addCase(fetchSystemErrorLogs.fulfilled, (state, action) => {
        state.list.loading = false;
        state.list.records = action.payload.data?.records || [];
        state.list.total = action.payload.data?.total || 0;
        state.list.current = action.payload.data?.current || 1;
        state.list.size = action.payload.data?.size || 10;
        
        // 保存搜索参数
        if (action.payload.params) {
          state.list.searchParams = {
            ...state.list.searchParams,
            ...action.payload.params
          };
        }
      })
      .addCase(fetchSystemErrorLogs.rejected, (state, action) => {
        state.list.loading = false;
        state.list.error = action.payload;
        message.error(action.payload || '获取系统错误日志失败');
      });
  }
});

export const { setSearchParams, clearError } = systemErrorLogSlice.actions;

export default systemErrorLogSlice.reducer;








